
import { Button } from "@/components/ui/button";
import { Loader2, Save, RotateCcw } from "lucide-react";

interface ReferralRulesActionsProps {
  onSave: () => void;
  onReset: () => void;
  isSaving: boolean;
  hasUnsavedChanges: boolean;
  isModuleEnabled: boolean;
}

export const ReferralRulesActions = ({ 
  onSave, 
  onReset, 
  isSaving, 
  hasUnsavedChanges, 
  isModuleEnabled 
}: ReferralRulesActionsProps) => {
  const isDisabled = !isModuleEnabled;

  return (
    <div className="flex gap-3 pt-4 border-t">
      <Button 
        onClick={onSave}
        disabled={isSaving || !hasUnsavedChanges || isDisabled}
        className="flex items-center gap-2"
      >
        {isSaving ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Save className="h-4 w-4" />
        )}
        {isSaving ? "Salvando..." : "Salvar Configurações"}
      </Button>
      
      {hasUnsavedChanges && isModuleEnabled && (
        <Button 
          variant="outline" 
          onClick={onReset}
          className="flex items-center gap-2"
        >
          <RotateCcw className="h-4 w-4" />
          Cancelar
        </Button>
      )}
    </div>
  );
};
